<template>
  <BaseMemberSelect
    v-model="feedbackSenderIds"
    :error="props.membersError"
    :filter="props.memberFilter"
    :autofocus="props.autofocusMembers"
    :show-select-all-button="props.showSelectAllButton"
    :label="label"
    display-selected="list"
    :description="description"
    :include-self="includeSelf"
  />
</template>

<script setup lang="ts">
  import BaseMemberSelect from '@/core/components/base/member-select/BaseMemberSelect.vue'

  interface Props {
    membersError?: string
    autofocusMembers?: boolean
    memberFilter?: 'coachees' | 'non-coachees' | 'all'
    showSelectAllButton?: boolean
    label?: string
    description?: string
    includeSelf?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    membersError: undefined,
    recurrenceIntervalError: undefined,
    showMembers: true,
    showRecurrence: true,
    autofocusMembers: false,
    memberFilter: 'all',
  })

  const feedbackSenderIds = defineModel<string[]>('feedbackSenderIds', { required: true })
</script>
